import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultControlStyle(instance) {
  if (!getDefaultControlStyle.style) {
    getDefaultControlStyle.style = {};
  }

  if (!getDefaultControlStyle.style[instance.args.designMode]) {
    getDefaultControlStyle.style[instance.args.designMode] = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        overflow: 'visible',
        left: '0px', //-1
        right: '0px', //-1
        top: '0',
        bottom: '0',
        transform: 'translate3d(0,0,0)',
        transition: 'all ${schemeAnimationDuration} ease 0s',
        boxSizing: 'border-box',
        display: 'block',
        opacity: 1,
        //border:"1px solid blue"
        filter: 'drop-shadow(0px 0px ${shadowBlur}px ${shadowColor})',
        shadowBlur: 10,
        shadowColor: '#000000',
        zIndex: 500,
      }),
      hover: {
        opacity: 1,
      },
      collapsed: {
        opacity: 1,
      },
      top: {
        normal: {
          bottom: 'auto',
          filter: 'drop-shadow(0px 10px ${shadowBlur}px ${shadowColor})',
          clipPath:
            'polygon(1px 0px, calc(100% - 1px) 0px, calc(100% - 1px) calc(100% + 50px), 1px calc(100% + 50px))',
        },
        collapsed: {
          filter: 'drop-shadow(0px 0px ${shadowBlur}px ${shadowColor})',
          transform: 'translate3d(0,-100%,0)',
          clipPath:
            'polygon(0 calc(100% - ${collapsedOffset}), 100% calc(100% - ${collapsedOffset}), 100% calc(100% + 50px), 0% calc(100% + 50px))',
        },
      },
      right: {
        normal: {
          filter: 'drop-shadow(-10px 0px ${shadowBlur}px ${shadowColor})',
          left: 'auto',
          clipPath: 'polygon(-50px 0, 100% 0, 100% 100%, -50px 100%)',
        },
        collapsed: {
          filter: 'drop-shadow(0px 0px ${shadowBlur}px ${shadowColor})',
          transform: 'translate3d(100%,0,0)',
          clipPath: 'polygon(-50px 0, ${collapsedOffset} 0, ${collapsedOffset} 100%, -50px 100%)',
        },
      },
      bottom: {
        normal: {
          top: 'auto',
          filter: 'drop-shadow(0px -10px ${shadowBlur}px ${shadowColor})',
          clipPath: 'polygon(1px -50px, calc(100% - 1px) -50px, calc(100% - 1px) 100%, 1px 100%)',
        },
        collapsed: {
          filter: 'drop-shadow(0px 0px ${shadowBlur}px ${shadowColor})',
          transform: 'translate3d(0,100%,0)',
          clipPath: 'polygon(0% -50px, 100% -50px, 100% ${collapsedOffset}, 0% ${collapsedOffset})',
        },
      },
      left: {
        normal: {
          filter: 'drop-shadow(10px 0px ${shadowBlur}px ${shadowColor})',
          right: 'auto',
          clipPath: 'polygon(1px 0px, calc(100% + 50px) 0, calc(100% + 50px) 100%, 1px 100%)',
        },
        collapsed: {
          filter: 'drop-shadow(0px 0px ${shadowBlur}px ${shadowColor})',
          transform: 'translate3d(-100%,0,0)',
          clipPath:
            'polygon(calc(100% - ${collapsedOffset}) 0, calc(100% + 50px) 0, calc(100% + 50px) 100%, calc(100% - ${collapsedOffset}) 100%)',
        },
      },
      body: {
        normal: merge({}, getDefaultStyle(), {
          overflow: 'hidden',
          boxSizing: 'border-box',
          padding: '0px',
          fontSize: '12px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '${schemeForeground}',
          backgroundColor: '${schemeSysBackground}',
          //position: 'relative',
          transition: 'all ${schemeAnimationDuration} ease 0s',
          display: 'block',
          borderStyle: 'none',
          borderColor: '#808080',
          borderWidth: '1px',
          borderTopWidth: '0px',
          borderBottomWidth: '0px',
          borderRightWidth: '0px',
          borderLeftWidth: '0px',
          borderRadius: '0px',
          opacity: 1,
          //clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
        }),
        hover: {},
        collapsed: {
          // padding:'0px',
          // opacity: 0,
          // height: 0,
          // overflow: 'hidden',
          pointerEvents: 'none',
        },
        top: {
          normal: {
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px',
            // borderBottomWidth: '1px',
            // borderTop:'none',
            // transformOrigin: 'center bottom',
          },
          collapsed: {
            // transform: 'perspective(1500px) rotateX(90deg)',
            // borderBottomColor:'${backgroundColor}',
            // height:0
          },
        },
        right: {
          normal: {
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',
            // borderLeftWidth: '1px',
            // borderRight:'none',
            height: '100%',
            // transformOrigin: 'left center',
          },
          collapsed: {
            // transform: 'perspective(1500px) rotateY(90deg)',
            // borderLeftColor:'${backgroundColor}',
          },
        },
        bottom: {
          normal: {
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '0px',
            // borderTopWidth: '1px',
            // borderBottom:'none',
            // transformOrigin: 'center top',
          },
          collapsed: {
            // transform: 'perspective(1500px) rotateX(90deg)',
            // borderTopColor:'${backgroundColor}',
          },
        },
        left: {
          normal: {
            borderBottomLeftRadius: '0px',
            borderTopLeftRadius: '0px',
            // borderRightWidth: '1px',
            // borderLeft:'none',
            height: '100%',
            // transformOrigin: 'right center',
          },
          collapsed: {
            // transform: 'perspective(1500px) rotateY(-90deg)',
            // borderRightColor:'${backgroundColor}',
          },
        },
      },
      tab: {
        normal: {
          cursor: 'pointer',
          position: 'absolute',
          transition: 'all ${schemeAnimationDuration}',
          boxSizing: 'content-box',
          display: 'block',
          transformOrigin: 'center top',
          overflow: 'visible',
          width: '100px',
          height: '25px',
          // borderTop: 'calc(1px + ${borderWidth} / 2) solid ${backgroundColor}',
          offset: 0,
        },
        collapsed: {
          // borderTop: 'calc(1px + ${borderWidth}) solid ${backgroundColor}',
        },
        topline: {
          normal: {
            opacity: 1,
            transition: 'opacity ${schemeAnimationDuration} ease 0s',
            stroke: '${borderColor}',
            strokeWidth: '${borderWidth}',
          },
          expanded: {
            opacity: 0,
          },
        },
        tongue: {
          fill: '${backgroundColor}',
          stroke: '${borderColor}',
          strokeWidth: '${borderWidth}',
        },
        noborder: {
          fill: '${backgroundColor}',
          //stroke: '${backgroundColor}',
          stroke: 'transparent',
          strokeWidth: '${borderWidth}',
        },
        icon: {
          normal: {
            transition: 'all ${schemeAnimationDuration} ease 0s',
            transformOrigin: 'center',
            fill: '${borderColor}',
            opacity: '0.7',
          },
          expanded: {
            transform: 'rotate(180deg)',
          },
          hover: {
            opacity: '1',
          },
        },
        top: {
          middle: {
            bottom: '1px',
            left: 'calc(50% ${tabOffset})',
            transform: 'translate3d(-50%,100%,0)',
          },
          begin: {
            left: 'calc(${borderRadius} + 1px ${tabOffset})',
            transform: 'translate3d(0,100%,0)',
          },
          end: {
            left: 'auto',
            right: 'calc(${borderRadius} + 1px ${tabOffset})',
            transform: 'translate3d(0,100%,0)',
          },
        },
        right: {
          middle: {
            left: '1px',
            top: 'calc(50% ${tabOffset})',
            transform: 'translate3d(-50%, 0%,0) rotate(90deg)',
          },
          begin: {
            top: 'calc(51px + ${borderRadius} ${tabOffset})',
            transform: 'translate3d(-50%,0,0) rotate(90deg)',
          },
          end: {
            top: 'auto',
            bottom: 'calc(26px + ${borderRadius} ${tabOffset})',
            transform: 'translate3d(-50%,0,0) rotate(90deg)',
          },
        },
        bottom: {
          middle: {
            top: '1px',
            left: 'calc(50% ${tabOffset})',
            transformOrigin: 'center',
            transform: 'translate3d(-50%,-100%,0) rotate(180deg)',
          },
          begin: {
            left: 'calc(${borderRadius} + 1px ${tabOffset})',
            transform: 'translate3d(0,-100%,0) rotate(180deg)',
          },
          end: {
            left: 'auto',
            right: 'calc(${borderRadius} + 1px ${tabOffset})',
            transform: 'translate3d(0,-100%,0) rotate(180deg)',
          },
        },
        left: {
          middle: {
            right: '1px',
            top: 'calc(50% ${tabOffset})',
            transform: 'translate3d(50%, 0%,0) rotate(-90deg)',
          },
          begin: {
            top: 'calc(51px + ${borderRadius} ${tabOffset})',
            transform: 'translate3d(50%,0,0) rotate(-90deg)',
          },
          end: {
            top: 'auto',
            bottom: 'calc(26px + ${borderRadius} ${tabOffset})',
            transform: 'translate3d(50%,0,0) rotate(-90deg)',
          },
        },
      },
      dataLED: {
        normal: {
          position: 'absolute',
          top: 'auto',
          right: 'auto',
          bottom: '-16px',
          left: '5px',
          width: '16px',
          height: '16px',
          backgroundImage: 'url("${iconUrl}")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          borderRadius: '50%',
          transition: 'all ${schemeAnimationDuration} ease 0s',
          boxSizing: 'border-box',
        },
        active: {
          backgroundColor: '${ledColor}',
          boxShadow: '0px 0px 6px 2px ${ledColor}',
        },
        topAttached: {
          begin: {
            top: 'auto',
            right: 'auto',
            bottom: '-16px',
            left: 'calc(4px ${ledOffset})',
          },
          end: {
            top: 'auto',
            right: 'calc(4px ${ledOffset})',
            bottom: '-16px',
            left: 'auto',
          },
        },
        rightAttached: {
          begin: {
            top: 'calc(4px ${ledOffset})',
            left: '-15px',
            bottom: 'auto',
            right: 'auto',
          },
          end: {
            top: 'auto',
            left: '-15px',
            bottom: 'calc(4px ${ledOffset})',
            right: 'auto',
          },
        },
        bottomAttached: {
          begin: {
            bottom: 'auto',
            right: 'auto',
            top: '-16px',
            left: 'calc(4px ${ledOffset})',
          },
          end: {
            bottom: 'auto',
            right: 'calc(4px ${ledOffset})',
            top: '-16px',
            left: 'auto',
          },
        },
        leftAttached: {
          begin: {
            top: 'calc(4px ${ledOffset})',
            right: '-15px',
            bottom: 'auto',
            left: 'auto',
          },
          end: {
            top: 'auto',
            right: '-15px',
            bottom: 'calc(4px ${ledOffset})',
            left: 'auto',
          },
        },
        top: {
          begin: {
            bottom: 'auto',
            right: 'auto',
            top: '4px',
            left: 'calc(4px ${ledOffset})',
          },
          end: {
            bottom: 'auto',
            right: 'calc(4px ${ledOffset})',
            top: '4px',
            left: 'auto',
          },
        },
        right: {
          begin: {
            top: 'calc(4px ${ledOffset})',
            left: 'auto',
            bottom: 'auto',
            right: '4px',
          },
          end: {
            top: 'auto',
            left: 'auto',
            bottom: 'calc(4px ${ledOffset})',
            right: '4px',
          },
        },
        bottom: {
          begin: {
            bottom: '4px',
            right: 'auto',
            top: 'auto',
            left: 'calc(4px ${ledOffset})',
          },
          end: {
            bottom: '4px',
            right: 'calc(4px ${ledOffset})',
            top: 'auto',
            left: 'auto',
          },
        },
        left: {
          begin: {
            top: 'calc(4px ${ledOffset})',
            right: 'auto',
            bottom: 'auto',
            left: '4px',
          },
          end: {
            top: 'auto',
            right: 'auto',
            bottom: 'calc(4px ${ledOffset})',
            left: '4px',
          },
        },
      },
    };
  }

  // console.log(
  //   _.filterDeep(getDefaultControlStyle.style, (v, k) => k == 'transition')
  // );
  return getDefaultControlStyle.style[instance.args.designMode];
}

export function getDefaultControl() {
  // console.log('getDefaultControl');
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('io-controls');
    // getDefaultControl.source.classList.add('controls');
    getDefaultControl.source.innerHTML = [
      // '<div class="frame">',
      '<div class="body"></div>',
      '<svg xmlns="http://www.w3.org/2000/svg" class="tab" viewBox="0 0 100 26">',
      // '  <path class="topline"',
      // '     d="M -1000,0 L 1100,0"',
      // '     fill="transparent" stroke="#cccccc" stroke-width="1"',
      // '     stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />',
      '  <path class="noborder"',
      '     d="M 0,1 L 100,1 100,-3 0,-3 Z"',
      '     stroke="#CCCCCC" fill="#CCCCCC" stroke-width="1"',
      '     stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />',

      '  <path class="tongue"',
      '     d="M -3000,0 L 0,0 C 25,0 25,25 50,25 75,25 75,0 100,0 L 3100, 0"',
      '     stroke="#CCCCCC" stroke-width="1"',
      '     stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />',

      '  <path class="tongue-noborder"',
      '     d="M 0,0 C 25,0 25,25 50,25 75,25 75,0 100,0"',
      '     stroke="#CCCCCC" stroke-width="1"',
      '     stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" />',

      '  <path class="icon"',
      '    d="M 45,12 l 5,5 l 5,-5 Z"',
      '    fill="#CCCCCC" stroke="transparent" stroke-width="0" />',
      '</svg>',
      '<div class="data-loading-indicator io-controls"></div>',
      // '</div>',
    ].join(' ');
  }

  return getDefaultControl.source.cloneNode(true);
}
